enum NoRepairReasonEnum {
  ASSESSMENT = 'assessment',
  TOTAL_LOSS = 'totalLoss'
}

export default NoRepairReasonEnum;
